import { CSSProperties } from "react";
import { workflowDiagramStyles } from "../workflowDiagramStyles";

export const nodeStyles = {
  base: {
    // boxSizing: "border-box",
    // TODO size node positions to match dynamic node element size
    // width: nodeWidth,
    // height: nodeHeight,
    borderRadius: 6,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    color: workflowDiagramStyles.colors.text,
    border: "1.5px solid rgba(26, 28, 33, 0.55)",
    fontSize: 15,
    lineHeight: 1.25,
    minWidth: 200,
  } satisfies CSSProperties,
  name: {
    fontWeight: 600,
    textOverflow: "ellipsis",
    padding: "0px 25px 25px 20px",
  } satisfies CSSProperties,
  subLabel: {
    marginTop: -23,
    marginBottom: 5,
    opacity: 0.6,
  } satisfies CSSProperties,
  unusedHandle: { opacity: 0, pointerEvents: "none" } satisfies CSSProperties,
  headerFlexContainer: {} satisfies CSSProperties,
};
